
import React from 'react';
import ServicesList from '@/components/ServicesList';
import ServicesFooter from './ServicesFooter';
import SectionHeader from '@/components/SectionHeader';
import TechBackground from '@/components/ui/TechBackground';
import SectionTransition from '@/components/ui/SectionTransition';

const Services = () => {
  return (
    <section id="services" className="py-1 md:py-4 relative overflow-hidden">
      <div className="container mx-auto px-3 sm:px-4 relative z-10">
        <SectionHeader
          title="Our Solutions"
          subtitle="Supporting your startup journey from concept to scale"
          emoji="🚀"
          titleColor="text-white"
        />

        <SectionTransition 
          type="scale" 
          delay={0.1} 
          className="mt-2 md:mt-4"
        >
          <TechBackground variant="default" glow="blue" className="p-3 md:p-4">
            <ServicesList />
          </TechBackground>
        </SectionTransition>
        
        <SectionTransition type="fade" delay={0.3}>
          <ServicesFooter />
        </SectionTransition>
      </div>
    </section>
  );
};

export default Services;
